<template>
  <v-app>
    <v-app-bar density="compact">
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
      <v-app-bar-title @click="$router.push('/')" class="cursor-pointer">{{ $t('app.title') }}</v-app-bar-title>
      <v-switch v-model="darkTheme" @update:model-value="changeTheme"
        :prepend-icon="darkTheme ? mdiWeatherNight : mdiWeatherSunny" hide-details class="mr-4 ml-auto"/>
      <v-select v-model="selectedLang" :items="selectableLangages" :label="$t('app.language')" hide-details inset
        class="mr-4 language-selector" style="max-width: 200px;" variant="underlined" density="compact"></v-select>
    </v-app-bar>
    <v-main>
      <router-view :lang="selectedLang" />
    </v-main>
    <v-footer border style="flex: none">
      <div class="flex-1-0-100 text-center">
        Copyright &copy; {{ new Date().getFullYear() }} <strong>Pocketpair, Inc.</strong>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import { ref } from 'vue'
import { useTheme } from 'vuetify'
import { mdiWeatherNight, mdiWeatherSunny, mdiTranslate } from '@mdi/js'

export default {
  name: 'App',
  setup() {
    const theme = useTheme()
    const darkTheme = ref(window.matchMedia('(prefers-color-scheme: dark)').matches)

    const changeTheme = () => {
      theme.global.name.value = darkTheme.value ? 'dark' : 'light'
    }

    changeTheme()

    return {
      darkTheme,
      changeTheme,
      mdiWeatherNight,
      mdiWeatherSunny,
      mdiTranslate
    }
  },
  data() {
    return {
      selectedLang: "en_US",
      selectableLangages: [],
      // 言語コードと表示名、ファイル名のマッピング
      languageMap: {
        ja_JP: "日本語",
        en_US: "English",
        zh_Hans: "中文",
      }
    }
  },
  mounted() {
    Object.keys(this.languageMap).forEach((key) => {
      const value = this.languageMap[key]
      this.selectableLangages.push({ title: value, value: key })
      if (this.$i18n.locale.includes(key)) {
        this.selectedLang = key
      }
    })
    this.disableInputs()
      this.$i18n.locale = this.selectedLang
      document.querySelector('html').setAttribute('lang', this.selectedLang)
  },
  watch: {
    selectedLang() {
      this.$i18n.locale = this.selectedLang
      document.querySelector('html').setAttribute('lang', this.selectedLang)
    },
  },
  methods: {
    disableInputs() {
      var inputs = document.querySelectorAll(".language-selector input")
      inputs.forEach((input) => {
        input.setAttribute("readonly", "readonly")
        input.setAttribute("disabled", "")
      })
    },
  }
}
</script>

<style>
/* .language-selector input{
  position: absolute;
  left: 25vw;
} */
</style>
